// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/stylesheet/styles.scss'
import VueLiDate from 'vuelidate'
import commonMixin from '@/common/mixin'
import InfiniteLoading from 'vue-infinite-loading'
import ElementUI from 'element-ui'
import VueToastr from 'vue-toastr'
import VModal from 'vue-js-modal'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(InfiniteLoading)
Vue.use(VueLiDate)
Vue.mixin(commonMixin)
Vue.use(ElementUI)
Vue.use(VueToastr, {
  defaultTimeout: 4000,
  defaultProgressBar: true,
  defaultType: 'error',
  defaultPosition: 'toast-top-right',
  defaultCloseOnHover: true,
  closeOnHover: true,
  defaultStyle: { 'margin-top': '15px' }
})
Vue.use(VModal)

/* eslint-disable no-new */
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js